<template>
    <div class="studbook-entry-status flex gap-3 align-items-center">
            <div class="label mt-1">{{ $t('message.horsePreview.studbook.statusLabel') }}:</div>
            <div v-if="horse.horseStatus === 'REGISTER_IN_STUDBOOK' || horse.horseStatus === 'EXTERNAL'" class="value verified">
                {{ $t('message.horsePreview.studbook.verified') }}
                <i class="pi pi-check font-bold"/>
            </div>
            <div v-else-if="horse.horseStatus === 'NEW_FOAL' || horse.horseStatus === 'NEW_IMPORTED' || horse.horseStatus === 'WAITING_FOR_MARKING_DATA'
                    || horse.horseStatus === 'WAITING_FOR_LABORATORY' || horse.horseStatus === 'LABORATORY_DATA_ENTERED' " class="value pending">
                {{ $t('message.horsePreview.studbook.pending') }}
                <i class="pi pi-hourglass font-bold"/>
            </div>
            <div v-else-if="horse.horseStatus === 'NOT REJECTED'" class="value not-verified">
                {{ $t('message.horsePreview.studbook.notVerified') }}
                <i class="pi pi-times font-bold"/>
            </div>
            <div v-else>?</div>
        </div>
</template>

<script>
import CustomTextButton from "@/components/form/CustomTextButton.vue";
import CustomInputNumber from "@/components/form/CustomInputNumber.vue";
import CustomInputText from "@/components/form/CustomInputText.vue";
import CustomSelectOneHorseColor from "@/components/form/CustomSelectOneHorseColor.vue";
import CustomSelectOneHorseSex from "@/components/form/CustomSelectOneHorseSex.vue";
import CustomSelectOneBookType from "@/components/form/CustomSelectOneBookType.vue";

export default {
    name: "StudbookEntryStatus",
    components: {
        CustomSelectOneBookType,
        CustomSelectOneHorseSex, CustomSelectOneHorseColor,
        CustomInputText, CustomInputNumber,
        CustomTextButton
    },

    props: {
        horse: {
            type: Object,
            required: true,
        },
    },

};
</script>

<style lang="scss">
@import "../../../../../assets/theme/mytheme/variables";
    .studbook-entry-status {
        .label {
            font-size: 18px;
            text-transform: uppercase;
        }

        .value {
            font-family: var(--decor-font-family);
            font-size: 20px;
            padding: 0.25rem 0.5rem;
            border-radius: 7px;
        }

        .verified {
            background-color: var(--pastel-green-accept);
        }

        .pending {
            background-color: var(--pastel-yellow-pending);
        }

        .not-verified {
            background-color: var(--pastel-red-reject);
        }
    }
</style>
